import {
  PayoutInfo as KitPayoutInfo,
  RightIcon,
} from "lola-framework-ui-test";
import type { CSSProperties, JSX } from "react";

export interface PayoutInfoProps {
  title: string;
  subtitle: string;
  icon: JSX.Element;
  onChange?: () => void;
  background?: string;
  color?: string;
  fee?: string | JSX.Element;
  className?: string;
  style?: CSSProperties;
  showBackArrow?: boolean;
}

/**
 * Shared PayoutInfo adapter — uses kit component.
 * Flavor A style: RightIcon chevron when no fee / no back arrow.
 */
export const PayoutInfo: React.FC<PayoutInfoProps> = ({
  title,
  subtitle,
  icon,
  onChange,
  background,
  color = "#252525",
  fee,
  className = "",
  style,
  showBackArrow = false,
}) => {
  const resolvedFee =
    fee ??
    (!showBackArrow ? (
      <RightIcon
        size={30}
        colors={[color, color]}
        className="bg-transparent"
      />
    ) : undefined);

  return (
    <KitPayoutInfo
      title={title}
      subtitle={subtitle}
      icon={icon}
      onChange={onChange}
      iconColor={color}
      textColor={color}
      alternativeTextColor={color}
      fee={resolvedFee}
      className={className}
      style={
        {
          ...style,
          "--payout-cta-color": color,
        } as CSSProperties
      }
      background={background}
      showBackArrow={showBackArrow && !fee}
    />
  );
};
